export const formatPriceCompact = (price) => {
  return (price / 100).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
};
